import _ from 'lodash';
import Cents from 'goodeggs-money';
import moment from 'moment-timezone';
import enums from 'goodeggs-purchase-orders-sdk/enums';
import foodhubs from 'goodeggs-foodhubs';
import lineItemHelpers from 'goodeggs-purchase-orders-sdk/line_item/helpers';

export default ngInject(function(
  $filter,
  $scope,
  $rootScope,
  $state,
  purchaseOrder,
  lineItems,
  catalogItems,
  catalogItemsById,
  vendor,
  newHash,
  inactiveLink,
) {
  $scope.foodhub = foodhubs.bySlug(purchaseOrder.foodhubSlug);
  $scope.vendor = vendor;
  $scope.enums = enums;
  $scope.catalogItems = catalogItems;
  $scope.catalogItemsById = catalogItemsById;
  $scope.purchaseOrder = purchaseOrder;
  $scope.lineItems = lineItems.filter(
    (lineItem) => !['edited', 'cancelled'].includes(lineItem.status),
  );

  $scope.collateralType = 'Purchase Order';

  $scope.cancelledLineItems = lineItems.filter((lineItem) => lineItem.status === 'cancelled');
  $scope.editedLineItems = lineItems.filter((lineItem) => lineItem.status === 'edited');
  $scope.editedLineItemsById = _.keyBy($scope.editedLineItems, (lineItem) => lineItem._id);

  $scope.getPrevUnitPrice = function(lineItem) {
    if (lineItem.editSequenceNumber === purchaseOrder.editSequenceNumber - 1) {
      const original = $scope.editedLineItemsById[lineItem.parentRef];
      if (original && original.unitPrice !== lineItem.unitPrice) {
        return original.unitPrice;
      }
    }
  };

  $scope.getCurrentQuantity = function(lineItem, property) {
    if (property == null) {
      property = purchaseOrder.status === 'confirmed' ? 'confirmedQuantity' : 'orderQuantity';
    }
    const catalogItem = catalogItemsById[lineItem.catalogId];
    return lineItemHelpers.convertQuantityToCatalogUnits(lineItem, property, catalogItem);
  };

  $scope.getPrevQuantity = function(lineItem) {
    // we should only ever be submitting if status is 'new', submitted' or 'confirmed'
    const property = purchaseOrder.status === 'confirmed' ? 'confirmedQuantity' : 'orderQuantity';
    if (lineItem.editSequenceNumber === purchaseOrder.editSequenceNumber - 1) {
      const original = $scope.editedLineItemsById[lineItem.parentRef];
      if (!original) {
        return;
      }
      const originalQuantity = $scope.getCurrentQuantity(original, property);
      const currentQuantity = $scope.getCurrentQuantity(lineItem, property);
      if (originalQuantity !== currentQuantity) {
        return original[property];
      }
    }
  };

  // TODO: this should display more like what we have in the 'show' ui state.
  // TODO(serhalp) this is duplicated in several places - remove and call helper
  $scope.displayLineItemName = function(lineItem) {
    const catalogItem = catalogItemsById[lineItem.catalogId];
    if ((catalogItem != null ? catalogItem.sku : undefined) != null) {
      return `(${catalogItem.sku}) ${catalogItem.name}`;
    }
    return catalogItem != null ? catalogItem.name : undefined;
  };

  $scope.isPickup = $scope.purchaseOrder.dropoffWindow === 'backhaul';
  $scope.deliveryType = $scope.isPickup ? 'pickup' : 'delivery';
  $scope.thirdPanelLabel = $scope.isPickup ? 'Pickup' : 'Delivery Window';

  $scope.changes = [];
  $scope.lineItems.forEach(function(lineItem) {
    const unitsChanged = $scope.getPrevUnitPrice(lineItem) !== undefined;
    const quantityChanged = $scope.getPrevQuantity(lineItem) !== undefined;
    if (unitsChanged && quantityChanged) {
      $scope.changes.push(
        `Unit price and Quantity change of ${$scope.displayLineItemName(lineItem)}`,
      );
    }
    if (unitsChanged && !quantityChanged) {
      $scope.changes.push(`Unit price change of ${$scope.displayLineItemName(lineItem)}`);
    }
    if (!unitsChanged && quantityChanged) {
      return $scope.changes.push(`Quantity change of ${$scope.displayLineItemName(lineItem)}`);
    }
  });
  $scope.cancelledLineItems.forEach((lineItem) =>
    $scope.changes.push(`Cancelling of ${$scope.displayLineItemName(lineItem)}`),
  );
  if (purchaseOrder.isDeliveryUpdated) {
    $scope.changes.push(`Updated ${$scope.deliveryType} time`);
  }
  if (purchaseOrder.isConfirmByUpdated) {
    $scope.changes.push('Updated confirmation deadline');
  }

  $scope.Cents = function(data) {
    if (data == null) {
      data = 0;
    }
    return new Cents(data);
  };
  $scope.print = () => window.print();

  const lineItemPrice = (lineItem) =>
    new Cents(lineItem.unitPrice).times($scope.getCurrentQuantity(lineItem));

  $scope.displayLineItemPrice = (lineItem) => lineItemPrice(lineItem).toString();

  $scope.getPurchaseOrderSubtotal = function() {
    const subtotal = _.sumBy($scope.lineItems, (lineItem) => lineItemPrice(lineItem).toNumber());
    return new Cents(subtotal).toString();
  };

  $scope.canConfirmPurchaseOrder = () =>
    !inactiveLink && purchaseOrder.status === 'submitted' && !$scope.isPastConfirmByDeadline();

  $scope.isPurchaseOrderConfirmed = () => purchaseOrder.status === 'confirmed';

  $scope.isPurchaseOrderEffectivelyClosed = function() {
    const allLineItemsRemoved = () =>
      _.filter($scope.lineItems, (lineItem) => !['edited', 'cancelled'].includes(lineItem.status))
        .length === 0;
    return inactiveLink || allLineItemsRemoved() || $scope.isPastConfirmByDeadline();
  };

  $scope.isPastConfirmByDeadline = () =>
    purchaseOrder.status === 'submitted' && new Date() > moment(purchaseOrder.confirmBy).toDate();

  $scope.confirmPurchaseOrder = () => $state.go($state.current, {hash: newHash}, {reload: true});

  $scope.sortByLineItemNumber = (lineItem) => lineItem.number || Infinity;

  $scope.changePO = () => (window.location.href = $scope.mailToLink);

  $scope.displayOrderUnitFilter = $filter('displayOrderUnit');
  $scope.displayUnit = function(lineItem) {
    return $scope.displayOrderUnitFilter(lineItem);
  };
});
